export const buildPdfSplitGroups = (pages = [], mergeWithNextByPage = {}, removedPages = {}) => {
  const groups = [];
  let currentGroup = null;

  const activePages = (pages || []).filter((page) => !removedPages[page.page_number]);

  activePages.forEach((page) => {
    if (!currentGroup) {
      currentGroup = [];
      groups.push(currentGroup);
    }
    currentGroup.push(page.page_number);

    if (!mergeWithNextByPage[page.page_number]) {
      currentGroup = null;
    }
  });

  return groups;
};

// Suggested documents ([{ first_page, last_page }]) -> mergeWithNextByPage for buildPdfSplitGroups.
export const mergeWithNextFromDocuments = (documents = []) => {
  const merged = {};
  (documents || []).forEach(({ first_page: firstPage, last_page: lastPage }) => {
    for (let page = firstPage; page < lastPage; page += 1) {
      merged[page] = true;
    }
  });
  return merged;
};
